import script from "./ShowCartView.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowCartView.vue?vue&type=script&setup=true&lang=js"

import "./ShowCartView.vue?vue&type=style&index=0&id=8783cfd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8783cfd4"]])

export default __exports__